import CONSTANTS from "../constants";

const universalElasticConnectedListUtils = {

    // Functions from UniversalElasticConnectedListUtils.js ---------------------------------------------------------------
    getSearchType: (search) => {

        if (search.includes('type=tag')) {
            return 'tag';
        } else {
            return 'query'
        }
    },

    findFiltersToSet: (list, engineName, options) => {
        let filters = engineName === 'cxreports' ? { archived: options['Show Archived'].toString(), } : {};
        
        if (list.informationOwner) {
            let tempFilters = { ...filters, information_owner: list.informationOwner.value, }
            filters = tempFilters;
        }
        if (list.reportType) {
            let tempFilters = { ...filters, report_type: list.reportType.value, }
            filters = tempFilters;
        }
        if (list.sensitivity) {
            let tempFilters = { ...filters, sensitivity: list.sensitivity.value, }
            filters = tempFilters;
        }
        return filters;
    },

    getDropdownOption: (temp) => {
        const optionsArray = Object.keys(temp); // get an array/list of all options [Show Archived, Second Option, Third Option]
        let returnString = "";
        
        for (let i = 0; i < optionsArray.length; i++) {
            if (temp[optionsArray[i]] === true) {
                if (i > 0) {
                    returnString = returnString + ", " + optionsArray[i];
                } else {
                    returnString = optionsArray[i];
                }
            }
        }
        return returnString; // return the string of selected options
    },

    //Functions from IntellFormattedList.js --------------------------------------------------------------------------------------------------
    displaySourceType: (srcType) => {

        if (srcType) {
            CONSTANTS.SOURCE_TYPE.filter((item) => {
                if(srcType === item.value) {
                    srcType = item.label
                }
                return srcType;
            })
            return srcType;
        } else {
            return '';
        }
    },

    //Functions from EyesSelector.js -------------------------------------------------------------------------------------------------------------------

    // True if this eye is already saved on the report (accepts "on" or boolean true)
    getThisValue: (eyeKey, form = {}) => {
        const field = CONSTANTS.TENANT_SLUG_TO_EYES[eyeKey];
        return Object.prototype.hasOwnProperty.call(form, field)
            && (form[field] === 'on' || form[field] === 'true' || form[field] === true);
    },

    // Disable rule:
    // - always disabled in read mode
    // - disabled for the current workspace eye
    // - disabled if tenant-level lock says this eye must be on
    isLocked: (eyeKey, mode, tenant) => {
        if (mode === 'read') return true;

        // guard if tenant isn’t loaded yet
        if (!tenant || !tenant.tenant || !tenant.tenant.fields) return false;

        const tenantSlug = tenant.tenant.fields.tenantslug;
        if (tenantSlug && eyeKey.toLowerCase() === tenantSlug.toLowerCase()) return true;

        if (tenant.tenant.fields.eyesSelectionLock === 'true') {
            const forcedEyes = CONSTANTS.EYES_FOR_TENANT_VIEW[tenantSlug] || [];
            return forcedEyes.indexOf(CONSTANTS.TENANT_SLUG_TO_EYES[eyeKey]) > -1;
        }
        return false;
    },

    // Which eyes to show:
    // - show all - enforcement handled by isLocked()
    getListOfEyesToShow: (tenant) => {
        const keys = Object.keys(CONSTANTS.TENANT_SLUG_TO_EYES);
        const slug = tenant?.tenant?.fields?.tenantslug;
        if (!slug) return [];  // wait for tenant to load
        return keys;           // show everything; locking is handled elsewhere
    },


    //Functions from IntellEditReport.js -------------------------------------------------------------------------------
    addTag: (tagsArr, tag) => { 

        if(tagsArr && tagsArr.length > 0) {
            let tagsSet = new Set(tagsArr);
         
            if (tagsSet.has(tag)) {
                tagsSet.delete(tag);
            } else {
                tagsSet.add(tag);
            }
            return Array.from(tagsSet);
        } else {
            return [tag];
        }

    },

    //Functions from IntelligenceDisplay.js ------------------------------------------------------------------------------------------
    getTagsToDisplay: (tagArr) => {
        let tagsList = [];
        if (typeof tagArr === 'string') {
        tagArr = tagArr.split(',');
        }
        tagArr.forEach((tag) => {
        tagsList.push(tag)
        })
        return tagsList
    },

  
    formatUrl: (url) => {
        const httpString = "http://";
        const httpsString = "https://";

        if (url && url.substr(0, httpString.length).toLowerCase() !== httpString && url.substr(0, httpsString.length).toLowerCase() !== httpsString)
        url = httpsString + url;
        return url;
    },

    getRetObj: (data, tenant) => {
        if (data && data.fields && tenant && tenant.tenant) {

            let retObj = {
                id: data.fields && data.fields.id ? data.fields.id : '',
                contentID: data.contentID ? data.contentID : '',
                credibility: data.fields.credibility ? data.fields.credibility : '',
                date: data.fields.datepublished ? data.fields.datepublished : data.fields.date ? data.fields.date : '',
                informationOwner: data.fields.informationOwner ? data.fields.informationOwner : data.fields.information_owner ? data.fields.information_owner : tenant.tenant.fields.functionalInformationOwner,
                internal_comment: data.fields.internal_comment ? data.fields.internal_comment : data.fields.internalComment ? data.fields.internalComment : '',
                keyContact: data.fields.keyContact ? data.fields.keyContact : data.fields.key_contact ? data.fields.key_contact : '',
                note: data.fields.display_body ? data.fields.display_body : data.fields.note ? data.fields.note : '',
                reliability: data.fields.reliability ? data.fields.reliability : '',
                reportDate: data.fields.datepublished ? data.fields.datepublished : '',
                sensitivity: data.fields.sensitivity ? data.fields.sensitivity: '',
                source: data.fields.source ? data.fields.source : '',
                //SourceType - Backend expects reportType please keep
                sourceType: data.fields.source_type ? data.fields.source_type : data.fields.sourceType ? data.fields.sourceType : data.fields.reportType ? data.fields.reportType : data.fields.report_type ? data.fields.report_type : '',
                reportType: data.fields.reportType ? data.fields.reportType : data.fields.report_type ? data.fields.report_type : '',
                sourceLink: data.fields.sourceLink ? data.fields.sourceLink : data.fields.links ? data.fields.links : '',
                attachedImageList: data.fields.attached_image_list && data.fields.attached_image_list.length > 0 ? data.fields.attached_image_list.split(',') : [],
                attachedRefFileList: data.fields.attached_ref_file_list && data.fields.attached_ref_file_list.length > 0 ? data.fields.attached_ref_file_list.split(','): [],
                tags: data.fields.tags_ValueField ? data.fields.tags_ValueField : data.fields.tags ? data.fields.tags : '',
                title: data.fields.title ? data.fields.title :'',
                reporter: data.fields.reporter ? data.fields.reporter :'',
                gaviEyes: data.fields.gavi_eyes === "true" || data.fields.gaviEyes === "true" ? "on":"off",
                bmgfEyes: data.fields.bmgf_eyes === "true" || data.fields.bMGFEyes === "true" ? "on":"off",
                unicefEyes: data.fields.unicef_eyes === "true" || data.fields.uNICEFEyes === "true" ? "on":"off",
                whoEyes: data.fields.who_eyes === "true" || data.fields.wHOEyes === "true" ? "on":"off",
                chaiEyes: data.fields.chai_eyes === "true" || data.fields.cHAIEyes === "true" ? "on":"off",
                cepiEyes: data.fields.cepi_eyes === 'true' || data.fields.cEPIEyes === 'true' ? 'on' : 'off',
                pahoEyes: data.fields.paho_eyes === 'true' || data.fields.pahoEyes === 'true' ? 'on' : 'off',
                linksbridgeEyes: data.fields.linksbridge_eyes === 'true' || data.fields.linksbridgeEyes === 'true' ? 'on' : 'off',
                archived: data.fields.archived ? data.fields.archived : 'false',
                approved: data.fields.approved ? data.fields.approved : 'false',
                modified: data.fields.modified ? data.fields.modified :''
            };

            return retObj
        } else {
            return {};
        }
    },

    //Functions from AzureStorageFileDisplayList ---------------------------------------------------------------------------------------------
    getFileNameOnly: (url) => {
      const myBlobNameArray = url.split('/');
      return myBlobNameArray[myBlobNameArray.length -1];
    },

    
    getFullUrl: (fileName, svcName, folderName) => {
        if(fileName.indexOf('https://') < 0){
            return `https://${svcName}.blob.core.windows.net/${folderName}/${fileName}`;
        } else {
            return fileName
        }
        
    },

    //Functions from FileListFieldDisplay.js -------------------------------------------------------------------------------------
    getDisplayFileName: (url) => {
        const myBlobNameArray = url.split('/');

        return myBlobNameArray[myBlobNameArray.length -1];
    },

    // Functions from SearchResultsPage.js file --------------------------------------------------------------------------------------
    processQuery: (query) => {
        try {
            const decodedQuery = decodeURIComponent(query); // Decode the query
            const parsedQuery = JSON.parse(decodedQuery); // Parse the JSON string
            
            if (parsedQuery) {
                return parsedQuery.query || parsedQuery; // Return `query` if it exists, otherwise return the full object
            }
        } catch (e) {
            return null;
        }
        return null; // Return null if decoding or parsing fails
    },

    convertToPrefsList: (objArray) => {
        if (objArray && objArray.length > 0) {
            return objArray.map( (item) => {
                let itemArray = item.rowKey ? item.rowKey.split('::'): [];
                if (itemArray && itemArray.length > 0) {
                    return { type: itemArray[0], for: itemArray[1], target: itemArray[2]};
                } else {
                    return null;
                }
            });
        } else {
            return [];
        }
    },
    getBodyHTML: (artItem) => {
        if(artItem &&artItem.fields && artItem.fields.previewText && artItem.fields.previewText.length > 1) {
            return artItem.fields.previewText;
        }
        
        if (artItem && artItem.highlight && artItem.highlight.length > 0) {
            return artItem.highlight[0];
        }
        else {
            if (artItem && artItem.fields && artItem.fields.body) {
                return artItem.fields.body.substr(0, 300)+'...'
            } 
        } 

        return '';
    },

    //RelatedArticleTeaser.js --------------------------------------------------------------------
    hasIntelligenceAccess: (tenant) => {
        let wkspcApps = tenant && tenant.tenant && tenant.tenant.fields && tenant.tenant.fields.apps ? tenant.tenant.fields.apps : null;

        if(wkspcApps && wkspcApps.length > 0) {
            return wkspcApps.findIndex( (thisItem) => { return thisItem.fields.apptype === 'intelligence'}) > -1;
        }

        return false;
    },

    findArticlesToShow: (articleList, articleID) => {
        if (articleID !== null && articleList && articleList.length > 0) {
            return articleList.filter( (item) => {
                return item.contentID !== articleID;
            })
        }
        return articleList;
    },

    createRelatedNewsArr: ( cx, news, entity ) => {

        let retArr = []
        let curArtArray = news && news.length > 0 ? news.filter((item) => {
            if(entity && entity.contentID && item && item.contentID) {
                return item.contentID.toString() !== entity.contentID.toString()
            }
            if (item && item.contentid && entity && entity.contentid) {
                return item.contentid.toString() !== entity.contentid.toString()
            }
            return false;
        }): null;

        retArr[0] = cx && cx.length > 0 ? cx[0] : curArtArray && curArtArray.length > 0 ? curArtArray[0] : null;
        retArr[1] = (cx && cx.length > 0) && (curArtArray && curArtArray.length > 0) ? curArtArray[0] : curArtArray && curArtArray.length > 1 ? curArtArray[1] : null;
        retArr[2] = (cx && cx.length > 0) && (curArtArray && curArtArray.length > 1) ? curArtArray[1] : curArtArray && curArtArray.length > 2 ? curArtArray[2] : null;

        let articleArray = retArr.filter((item) => item !== null)

        return articleArray;
    },
}

export default universalElasticConnectedListUtils;